import { ChatMessage } from '../../interfaces/Assistant';

/** O conversație salvată local pentru istoric. */
export interface StoredConversation {
  id: string; // = sessionId
  title: string; // primul mesaj al utilizatorului (trunchiat)
  preview: string; // ultimul mesaj (trunchiat)
  updatedAt: number;
  messages: ChatMessage[];
}

const STORE_KEY = 'assistant-conversations';
const MAX_CONVERSATIONS = 50;

function read(): StoredConversation[] {
  try {
    const raw = localStorage.getItem(STORE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

function write(list: StoredConversation[]): void {
  try {
    localStorage.setItem(STORE_KEY, JSON.stringify(list.slice(0, MAX_CONVERSATIONS)));
  } catch {
    /* quota plină — ignorăm */
  }
}

function truncate(s: string, n: number): string {
  const clean = (s || '').replace(/\s+/g, ' ').trim();
  return clean.length > n ? `${clean.slice(0, n - 1)}…` : clean;
}

/** Listează conversațiile, cele mai recente primele. */
export function listConversations(): StoredConversation[] {
  return read().sort((a, b) => b.updatedAt - a.updatedAt);
}

/** Filtrează conversațiile după text (titlu, preview sau conținut mesaje). */
export function searchConversations(query: string): StoredConversation[] {
  const q = query.trim().toLowerCase();
  const all = listConversations();
  if (!q) return all;
  return all.filter((c) => c.title.toLowerCase().includes(q) || c.preview.toLowerCase().includes(q) || c.messages.some((m) => (m.content || '').toLowerCase().includes(q)));
}

export function getConversation(id: string): StoredConversation | undefined {
  return read().find((c) => c.id === id);
}

/** Salvează (upsert) snapshotul conversației curente. */
export function saveConversation(id: string, messages: ChatMessage[]): void {
  if (!id || messages.length === 0) return;
  const firstUser = messages.find((m) => m.role === 'user');
  const last = messages[messages.length - 1];
  const list = read();
  const entry: StoredConversation = {
    id,
    title: truncate(firstUser?.content || 'Conversație', 60) || 'Conversație',
    preview: truncate(last?.content || '', 80),
    updatedAt: Date.now(),
    messages,
  };
  const idx = list.findIndex((c) => c.id === id);
  if (idx >= 0) list[idx] = entry;
  else list.push(entry);
  write(list);
}

export function deleteConversation(id: string): void {
  write(read().filter((c) => c.id !== id));
}
